import { DEAD_STATUS_ID } from '../janus-engine/death/state-ids.js';
import { brokenObjectHunkers, HUNKER_STATUS } from '../janus-engine/actions/hunker.js';
import { isSelfStatusOrigin } from '../janus-engine/statuses/status-origin.js';
import { arrivalPlacementPlans, campsiteInventoryPlan, geometryRelocation, relocationFailureMessage, reportRelocationAuthorityRefusal } from './geometry-relocation-truth';
import { encounterField, inventoryField, type CampaignArr } from '../shared/array-types.js';
import { _ftCamField } from '../shared/campaign-field.js';
import { rowScalar } from '../encounter-map/ft3d/perception.js';
import { normalizePhpListish } from '../shared/php-listish.js';
import { inventoryStatusTargets } from '../janus-engine/statuses/riding-removal.js';
import { HandBack, Refusal, ecId, ecLean, itemField, record, scalar, upper, type Row, type JanusCtx } from '../janus-engine/ability/context.js';
import { resolveGmBoundary, resolveCreatureVisibility, CREATURE_HIDDEN_STATUS, requireEndedTurn, TurnHolderRefusal, creatureName, boundaryVerdict, heldInventoryRows, resolveGmZoneEntry, resolveGmZoneExit, dueCascadeSources, resolveDueZoneExpiries, type GmBoundaryAction, type GmBoundaryVerdict } from '../janus-engine/statuses/gm-boundary.js';
import { statusItemId, STATUS_IDS, type ExpiryReaders } from '../janus-engine/statuses/expiry.js';
import { statusScalar } from '../janus-engine/actions/activity.js';
import { retainHeldBase } from '../janus-engine/ability/frame-snapshot.js';
import { holdsTaggedSummon as holdsLiveTaggedSummon } from '../janus-engine/death/summons.js';
import { frameCopyOnRead } from '../janus-engine/ability/frame-snapshot.js';
import { escapeHtml } from '../shared/cosmetic-card.js';
import { compoundActorIds } from '../janus-engine/movement/compound-drag.js';
import { ensureActorRowHeld } from '../shared/actor-row-loader.js';
import { getStatusEffectDurationTimes } from '../janus-engine/ability/statuses/get-status-effect-duration-times.js';
import { paoeEntryContext } from '../janus-engine/ability/paoe-entry.js';
import { hasSurfaceTypeValue } from '../janus-engine/ability/paoe-entry-once.js';
import { PAYLOAD_DRY_PATTERNS, payloadDryRunRollSource } from '../janus-engine/ability/environmental-payload.js';
import { exploreDryPatterns, pinnedDryEnv } from '../janus-engine/statuses/gm-dry-run.js';
import { createGmBoundarySettle, installedRevs, waitForSavedInstall, type SettleExpect } from './gm-boundary-settle.js';
import { browserRollSource } from '../janus-engine/actions/weapon-attack.js';
import { recordingRollSource, tapedRollSource, type RecordedDraw } from '../janus-engine/actions/roll-source.js';
import { TRIGGER_CONSENT_REASON } from '../janus-engine/ability/trigger-consent.js';
import { skipUnported, refuseUnported, withQuietUnported } from '../janus-engine/unported.js';
import { actorEncounterFor, actorRowFor, waitForActorMovement, movementScopeReaders } from './movement-truth.js';
import { abilityTruthReaders, abilityTruthCampaign, awaitObjectsInflight, hydrateTurnTriggerDefinitions, hydrateReferencedDefinitions, referencedDefinitionIds } from './ability-truth.js';
import { fullDefinition } from '../janus-engine/reactions/php-row-rules.js';
import { statusQuantityAlias } from '../janus-engine/ability/statuses/inventory-status-applicability.js';
import { createTriggerConsent, askTriggerConsent, offerFortunate } from './trigger-consent.js';
import { planGmRelocationZones, relocationTouchesNoZone } from './zone-truth.js';
import { uniqueZoneEntrants } from '../janus-engine/zones/walk-zone-crossings.js';
import { fetchAndCacheObject } from './object-cache.js';
import { readCreatureStatuses } from '../janus-engine/compile/creature-status-reader.js';
import { withoutEncumbranceApplication } from '../janus-engine/compile/encumbrance-application-plans';
import { resolveTeleportOfferLanding, TELEPORT_DISPLACEMENT_ID } from '../janus-engine/movement/teleport-offer-settlement.js';
import type {} from '../shared/teleport-placement.js';
import { hydratePaoeEntryRecords, adoptPaoeEntryRecords, ensurePaoeEntryRecords, onlySurfaceEntryZones, readSurfaceEntryRecords, rememberPaoeEntryLogRows } from './paoe-entry-records.js';
import { planSpellListSwitch, spellListSwitchGate, spellPrepHasCampaign, type SpellListSwitchPlan } from '../janus-engine/spells/spell-list-switch.js';
import { ARCANE_FATIGUE_ID } from '../janus-engine/spells/prepared-spells.js';
import { InventoryDamageFactsNeeded } from '../janus-engine/inventory/ability-damage.js';
import { hydrateInventoryDamageNeeds } from './ability-preflight-needs.js';
import { createObjectVitalityFactReader, hydrateInventoryObjectVitality } from './object-vitality.js';
import { fetchAndCacheCaster } from './caster-cache.js';
import { lazyDeathResources, prepareDeathResources, resumeDeathResources } from '../shared/spawn-browser.js';
import { compileFetchedEntity } from '../shared/compile-fetched-entity.js';
import { readPlayerCharacterField } from '../janus-engine/display/player-character-field.js';
import { HUNGER_THIRST_TICK, planCampaignNeedsToggle } from '../janus-engine/statuses/campaign-needs-toggle.js';
import { RECOVERY_STATUS_IDS } from '../janus-engine/resources/resource-recovery-plan.js';
import { hydrateRemovalSupportDefinitions } from '../janus-engine/statuses/removal-support.js';
import { exactRemovalTailDefinitionIds } from '../janus-engine/statuses/exact-removal-tails.js';
import { stageRowFamily } from '../janus-engine/statuses/stage-rows.js';
import { movementStatusDefinitionIds20, resolveMovementStatusInputs20, resolveMovementSqueeze20, resolveVisibilitySelection20, type MovementStatusInputs20 } from '../janus-engine/statuses/application-inputs-20.js';
import { squeezeStateAt } from '../janus-engine/movement/plain-walk-scope.js';
import { pageSceneShape } from '../janus-engine/geometry/perception-context.js';
import { composeCreatureDeletion22, renumberCreatureDeletion22 } from '../janus-engine/death/delete-plan-22.js';
import { gmStatusAppliedFrame } from '../janus-engine/transport/gm-applied-frame';
import type { AppliedFrameResult, AppliedFrameIdentity } from '../janus-engine/transport/applied-frame';
import { saveAppliedTruth } from '../shared/applied-truth-transport';
import { possessorSceneContext } from './possessor-scene';
import { carrierHasTrigger } from '../janus-engine/ability/statuses/status-trigger-gate';
import { recompileMemberStatusDiff } from '../janus-engine/compile/member-status-diff';
import { statusApplicableToTarget } from '../janus-engine/ability/statuses/inventory-status-applicability.js';
import { planInventoryDelete, planInventoryMoveTails, type InventoryMoveTails } from '../janus-engine/inventory/delete-plan';
import { withAsyncDeadline } from '../shared/async-deadline';
import { retireMemberChargePools } from '../janus-engine/transport/member-applied-frame';

import { planDestructionRemoval } from '../janus-engine/inventory/delete-plan';
import type { ObjectDestroyCommand } from '../janus-engine/inventory/destroy-object';
import { prepareRecursiveDeletion } from './recursive-delete-truth';

const appliedStatuses = new WeakMap<GmBoundaryVerdict, AppliedFrameResult>();

async function campaignToggleEntity(id: string, entity: 'pc' | 'encounter'): Promise<Row> {
  const response = await fetch(`/options/api/base_entity_inc.php?entity_id=${encodeURIComponent(id)}&entity=${entity}&cold=0`);
  if (!response.ok) throw new Error(`campaign-needs:base-read:${response.status}`);
  return compileFetchedEntity({ _entity_base: await response.json() });
}

/** Called by the turn-widget bundle through a window bridge; its save route receives only browser decisions. */
export async function prepareCampaignNeedsToggle(url: string, data: Row): Promise<boolean> {
  const route = new URL(url, window.location.href).pathname.split('/').pop();
  const downtime = route === 'toggle_campaign_downtime_enabled_inc.php';
  if (!downtime && route !== 'toggle_hunger_thirst_enabled_inc.php') return true;
  try {
    const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ campaign_id: data.campaign_id, mode: 'read' }) });
    if (!response.ok) throw new Error(`campaign-needs:roster:${response.status}`);
    const facts = record(await response.json());
    const campaign = record(facts?.campaign);
    if (!facts || !Array.isArray(facts.players) || !campaign) throw new Error('campaign-needs:roster-shape');
    window.FateTide ??= {};
    window.FateTide.campaignCache ??= new Map();
    window.FateTide.campaignCache.set(upper(_ftCamField(campaign, 'campaign_id')), campaign as CampaignArr);
    const enabled = Number(data[downtime ? 'campaign_downtime_enabled' : 'hunger_thirst_enabled']) === 1;
    if (downtime && enabled && Number(ftLayerValue(campaign, 'campaign_disable_player_haven_return') ?? 0) === 1)
      throw new Refusal('Haven return must be enabled before downtime can be enabled.');
    const groups = new Map<string, { encounter: Row; actors: string[] }>();
    if (!downtime || enabled) for (const raw of facts.players) {
      const id = upper(readPlayerCharacterField(raw, 'item_id'));
      const actor = await campaignToggleEntity(id, 'pc'), aid = ecId(actor), eid = upper(ecLean(actor, 'encounter_id'));
      if (!aid) throw new HandBack('campaign-needs:actor-not-held');
      const key = eid || aid;
      let group = groups.get(key);
      if (!group) {
        group = { encounter: eid ? await campaignToggleEntity(eid, 'encounter')
          : { encounter_master_parent_id: upper(readPlayerCharacterField(actor, 'attached_campaign_id')),
            campaign_arr: campaign, encounter_creatures_arr: [actor] }, actors: [] };
        groups.set(key, group);
      }
      if (!membersOf(group.encounter).has(aid)) throw new HandBack('campaign-needs:actor-not-in-roster');
      group.actors.push(aid);
    }
    const plans = [];
    for (const { encounter, actors } of groups.values()) {
      const aid = actors[0]!, eid = upper(encounterField(encounter, 'encounter_id'));
      const actor = membersOf(encounter).get(aid)!;
      const plan = await resolve(eid || aid, aid, encounter, ctx => {
        let verdict;
        for (const id of actors) verdict = planCampaignNeedsToggle(ctx, id, !downtime && enabled);
        return verdict!;
      }, [HUNGER_THIRST_TICK], true, false, true);
      const { fortunateOffers: _offers, memberExpectedRevs: _revs, ...saved } = plan;
      plans.push({ actor_id: aid, expected_rev: Number(ecLean(actor, 'movement_rev') ?? 0), plan: saved });
    }
    data.needs_plans = plans;
    data.campaign_updates = downtime ? enabled ? { campaign_downtime_enabled: 1, hunger_thirst_enabled: 0, waking_weariness_enabled: 0 }
      : { campaign_downtime_enabled: 0 } : { hunger_thirst_enabled: enabled ? 1 : 0 };
    data.toggle_log_type = `${downtime ? 'campaign_downtime' : 'hunger_thirst'}_${enabled ? 'enabled' : 'disabled'}`;
    return true;
  } catch (error) { reportBoundaryError(error, 'campaign-needs'); return false; }
}
Object.assign(window, { ftPrepareCampaignNeedsToggle: prepareCampaignNeedsToggle });

const membersOf = (encounter: Row): Map<string, Row> => new Map(normalizePhpListish(encounter.encounter_creatures_arr)
  .flatMap(value => { const row = record(value), id = ecId(row); return row && id ? [[id, row] as [string, Row]] : []; }));
const completeIds = (members: Map<string, Row>): Set<string> => new Set([...members]
  .filter(([, member]) => record(record(member.computed)?.creature) && record(member.item_layer_types)).map(([id]) => id));
const zoneSources = (encounter: Row): Row[] => [encounter, ...membersOf(encounter).values()]
  .flatMap(member => Object.values(readCreatureStatuses(member))).filter(status => Number(record(status)?.status_aoe_source ?? 0) === 1) as Row[];

function reportBoundaryError(error: unknown, prefix: string): void {
  if (reportRelocationAuthorityRefusal(error)) return;
  if (error instanceof Error && error.message.startsWith('relocation:')) {
    refuseUnported(error.message, undefined, relocationFailureMessage(error.message));
    return;
  }
  if (error instanceof Refusal) {
    window.displayWarning?.(escapeHtml(error.refusal));
    return;
  }
  refuseUnported(error instanceof HandBack ? error.reason : `${prefix}:${String(error)}`, undefined, undefined,
    error instanceof HandBack ? undefined : `${prefix}:exception`);
}

/** A saved verdict reaches this page through the live apply path (gm-boundary-settle.ts): the next GM tool waits for that install, so it
 *  decides from the saved rows and revision instead of the pre-save snapshot (which the save refuses as stale). Without an expected
 *  actor revision (a refusal, a stale save) the settle is the whole-encounter refetch. */
const boundarySettle = createGmBoundarySettle({ resync: id => window.ftResyncEncounter?.(id) ?? Promise.resolve() });
const SETTLE_WAIT_MS = 15000;
const recoverySettles = new Map<string, Promise<void>>();
export function settleGmBoundary(encounterId: string, expect?: SettleExpect, verdict?: GmBoundaryVerdict): Promise<void> {
  const settled = boundarySettle.settle(encounterId, expect);
  if (!verdict?.recovery) return settled;
  const key = upper(encounterId), recovery = verdict.recovery;
  const installed = (): boolean => {
    const encounter = record(actorEncounterFor(encounterId));
    if (!encounter) return false;
    const members = membersOf(encounter), held = heldInventoryRows({ encounter, members });
    const statuses = new Set([...members.values()].flatMap(row => Object.values(readCreatureStatuses(row)).map(status => upper(record(status)?.status_id))));
    const retired = (id: string): boolean => !held.has(id) || Number(inventoryField(held.get(id), 'inventory_deleted') ?? 0) === 1;
    return recovery.bodies.every(body => {
      const row = held.get(body.inventory_id), target = members.get(body.target);
      return target && Number(ecLean(target, 'encounter_creature_dead') ?? 0) === 0 && Number(ecLean(target, 'v_current') ?? 0) > 0
        && retired(body.inventory_id) && (!row || (!upper(inventoryField(row, 'inventory_encounter_creature_id')) && Number(inventoryField(row, 'item_qty') ?? 1) === 0));
    }) && recovery.monsterBitRemovals.every(part => retired(part.inventory_id))
      && verdict.statusesRemoved.every(status => !statuses.has(upper(status.status_id)));
  };
  const gate = settled.then(() => waitForSavedInstall({
    installed, recover: async () => {
      await window.ftResyncEncounter?.(encounterId);
      if (!installed()) throw new Error('gm-boundary:recovery-install-unconfirmed');
    }, pollMs: 25,
  })).finally(() => { if (recoverySettles.get(key) === gate) recoverySettles.delete(key); });
  recoverySettles.set(key, gate);
  return gate;
}
window.addEventListener('ft:status-truth-frame', event => {
  const detail = record((event as CustomEvent).detail), command = record(detail?.command);
  const verdict = record(command?.gm_boundary) as unknown as GmBoundaryVerdict | null;
  if (detail?.kind === 'committed' && verdict?.recovery && !command?.applied_frame)
    void settleGmBoundary(upper(command?.encounter_id), { actorId: upper(command?.actor_id), rev: Number(command?.rev), relay: true }, verdict)
      .catch(error => console.warn('[gm-boundary] saved recovery awaiting install', error));
});
// Bank every install's actor revisions: a full adopt from its RAW payload (ft:encounter-installed fires before movement-truth reconciles the
// rows, so a stale row lifted to a confirmed revision is never read), the delta's rows-patched pass, and post-C5 the base_patch compile.
window.addEventListener('ft:encounter-installed', event => {
  const arr = record(record((event as CustomEvent).detail)?.encounterArr);
  const id = upper(Array.isArray(record(arr?.encounters)?.encounter_id) ? (record(arr?.encounters)?.encounter_id as unknown[])[0] : record(arr?.encounters)?.encounter_id);
  if (arr && id) boundarySettle.bank(id, installedRevs(arr.encounter_creatures_arr), true, true);
});
window.addEventListener('ft:encounter-state-received', event => {
  // Only the delta's in-place rows-patched install; a full adopt banked above, and local repaints (zone / floor-move / object receipts)
  // re-dispatch cached rows whose revision may be this page's own reconcile.
  const detail = record((event as CustomEvent).detail);
  if (detail?.subType !== 'creature_rows_patched') return;
  const ids = Array.isArray(detail.changedCreatureIds) ? (detail.changedCreatureIds as unknown[]).map(upper) : [];
  boundarySettle.bank(upper(detail.encounterId), installedRevs(record(detail.encounterArr)?.encounter_creatures_arr, ids));
});
window.addEventListener('ft:entity-base-compiled', event => {
  const id = upper(record((event as CustomEvent).detail)?.entityId);
  const cache = window.FateTide?.encounterCache;
  if (!id || !(cache instanceof Map)) return;
  const encounter = record(cache.get(id));
  if (encounter) { boundarySettle.bank(id, installedRevs(encounter.encounter_creatures_arr), true); return; }
  for (const [encounterId, held] of cache) {
    const revs = installedRevs(record(held)?.encounter_creatures_arr, [id]);
    if (revs.length) boundarySettle.bank(String(encounterId), revs);
  }
});
window.addEventListener('ft:base-applied', event => {
  const wire = record((event as CustomEvent).detail)?.wire;
  const frame = (typeof wire === 'string' ? JSON.parse(wire) : record(wire)) as AppliedFrameResult | null;
  if (!frame || 'cache_ref' in frame) return;
  const encounter = record(actorEncounterFor(frame.encounter_id));
  if (encounter) boundarySettle.bank(frame.encounter_id, [
    ...installedRevs(encounter.encounter_creatures_arr, Object.keys(frame.member_revs)),
    // A departed actor has no roster row left to bank; this installed tombstone is its receipt.
    ...frame.deletes.filter(row => row.table === 'encounter_creatures' && !membersOf(encounter).has(upper(row.row_id))
      && Number.isInteger(frame.member_revs[upper(row.row_id)]))
      .map(row => [upper(row.row_id), frame.member_revs[upper(row.row_id)]!] as [string, number]),
  ]);
});
function settledGmBoundary(encounterId: string): Promise<void> {
  const pending = recoverySettles.get(upper(encounterId)) ?? boundarySettle.pending(encounterId);
  return pending ? Promise.race([pending, new Promise<void>(resolve => setTimeout(resolve, SETTLE_WAIT_MS))]) : Promise.resolve();
}
/** One GM tool action per encounter at a time on this page: a second click starts only after the first saved and its rows installed.
 *  A resync that fails or outlasts the wait still lets the next action run — the save then refuses it as stale, with words. */
const queues = new Map<string, Promise<unknown>>();
function oneAtATime<T>(encounterId: string, run: () => Promise<T>): Promise<T> {
  const key = upper(encounterId);
  const next = (queues.get(key) ?? Promise.resolve()).then(() => settledGmBoundary(key)).then(run);
  const tail = next.catch(() => undefined);
  queues.set(key, tail);
  void tail.then(() => { if (queues.get(key) === tail) queues.delete(key); });
  return next;
}

/** A real support consequence may need these; an ordinary GM add does not. */
class GmBoundaryInputsPending extends Error {
  constructor(readonly id: string) { super(`gm-boundary:inputs-pending:${id}`); }
}
/** A runtime-only add with fully held gain listeners needs no unrelated turn/death definitions.
 * Unknown carriers and statuses with compile/teardown duties keep the ordinary hydration path. */
function heldStatusAdd(encounter: Row, actorId: string, action: Extract<GmBoundaryAction, { kind: 'add' }>): boolean {
  const members = membersOf(encounter), target = members.get(upper(action.targetId)), caster = members.get(upper(action.casterId) || upper(action.targetId));
  if (!target || !caster) return false;
  const read = abilityTruthReaders(members.get(actorId) ?? target, encounter, completeIds(members));
  // The shared diff checks conditional dependencies as well as layer and identity dependencies.
  const diff = recompileMemberStatusDiff(target, [{ kind: 'add', statusItemId: action.itemId, casterId: ecId(caster) }],
    { definition: read.definition, catalog: record(encounter.catalog), roster: () => [...members.values()] });
  if (!diff?.ok || diff.creature !== record(record(target.computed)?.creature) || diff.vitality !== record(record(target.computed)?.vitality)) return false;
  const ctx = paoeEntryContext(encounter, members, read, payloadDryRunRollSource('max'), () => frameCopyOnRead(encounter, members, { catalogs: 'share' }));
  try {
    return !carrierHasTrigger(ctx, target, 'triggers_when_caster_gains_status_effect', 'gm-status-trigger', action.itemId)
      && (target === caster || !carrierHasTrigger(ctx, caster, 'triggers_when_target_gains_status_effect', 'gm-status-trigger', action.itemId));
  } catch { return false; }
}

async function resolve<T extends GmBoundaryVerdict>(encounterId: string, actorId: string, encounter: Row, operation: (ctx: JanusCtx) => T, sourceIds: string[] = [], requireHydration = false, reportWarmingProblems = true, prepareDeaths: boolean | 'lazy' = false, reportedSkipReasons?: ReadonlySet<string>, synchronousInputs = false, add?: Extract<GmBoundaryAction, { kind: 'add' }>): Promise<T> {
  const inventoryFacts = window as Window & {
    ftAbilityDamageLinkFacts?: (encounter: Row, actorId: string, ids: string[]) => Promise<boolean>;
  };
  const fetchedFacts = new Set<string>();
  const readObjectVitalityFact = createObjectVitalityFactReader(id => fetchAndCacheObject(id, { fresh: true }));
  const caster = membersOf(encounter).get(actorId) ?? membersOf(encounter).values().next().value ?? {};
  const lookup = abilityTruthReaders(caster, encounter, completeIds(membersOf(encounter))).definition;
  const dispatched: Row[] = [];
  const warmingProblems: string[] = [];
  const carrierIds = new Set(['BE42824F-46BE-EC80-AB7F-B823190AB6C8', 'F5ACBDB4-D923-3684-57F6-FBF3F720AEFA', '7A5F5C86-B457-462B-964F-33C5CFAF9BF7']);
  const checkedCarriers = new Set<string>();
  const requestedCarriers = new Set<string>();
  const dueCarriers = new Set<string>();
  const sources = [...new Set(sourceIds.map(id => statusQuantityAlias(id)?.id ?? id))];
  // Held raw inputs need no object read or definition compile, including one
  // still running for a card. Join only sources absent from this encounter.
  await awaitObjectsInflight(sources.filter(id => !lookup(id)));
  const held = await Promise.all(sources.map(async id => {
    try { return lookup(id) ?? record(await fetchAndCacheObject(id)); }
    catch { warmingProblems.push(`gm-boundary:source-hydration-unavailable:${id}`); return null; }
  }));
  for (const definition of held) if (definition) dispatched.push(definition);
  try { if (!add || !heldStatusAdd(encounter, actorId, add)) await hydrateTurnTriggerDefinitions(caster, encounter, dispatched); }
  catch { warmingProblems.push('gm-boundary:trigger-hydration-incomplete'); }
  if (requireHydration && warmingProblems.length) throw new HandBack(warmingProblems.join(';'));
  const campaign = abilityTruthCampaign(encounter);
  let boundaryEncounter = campaign ? { ...encounter, campaign_arr: campaign } : encounter;
  if (campaign) retainHeldBase(encounter, boundaryEncounter);
  const entryRead = abilityTruthReaders(caster, boundaryEncounter, completeIds(membersOf(boundaryEncounter)));
  if (dispatched.some(definition => hasSurfaceTypeValue(entryRead, definition))) {
    try { await ensurePaoeEntryRecords(boundaryEncounter, actorId, true); }
    catch { /* the surface receipt records a missing log window; this boundary still resolves */ }
  }
  // Movement can kill through displacement, status loss or entry damage. Bind the
  // shared source reader before preflight; surviving moves need no corpse inputs.
  const deathResources = prepareDeaths ? await (prepareDeaths === 'lazy' ? lazyDeathResources : prepareDeathResources)(
    Array.from(membersOf(boundaryEncounter).values()), boundaryEncounter, entryRead, campaign) : undefined;
  const consent = createTriggerConsent(encounterId);
  const pinned = pinnedDryEnv();
  const hydrateDueCarriers = async (): Promise<boolean> => {
    const due = [...dueCarriers].filter(id => !requestedCarriers.has(id));
    const definitions: Row[] = [];
    for (const id of due) {
      requestedCarriers.add(id);
      try {
        const definition = lookup(id) ?? record(await fetchAndCacheObject(id));
        if (definition) definitions.push(definition);
      } catch { warmingProblems.push(`gm-boundary:source-hydration-unavailable:${id}`); }
    }
    if (definitions.length) {
      try { await hydrateReferencedDefinitions(caster, boundaryEncounter, definitions); }
      catch { warmingProblems.push(`gm-boundary:carrier-reference-hydration-incomplete:${due.join(',')}`); }
    }
    return due.length > 0;
  };
  const run = (roll: JanusCtx['roll'], dryRun = false): T => {
    const members = membersOf(boundaryEncounter), caster = members.get(actorId) ?? members.values().next().value ?? {};
    const live = { ...abilityTruthReaders(caster, boundaryEncounter, completeIds(members)), geometry: movementScopeReaders(boundaryEncounter).geometry,
      triggerConsent: consent, deathResources };
    const definition = live.definition;
    live.definition = id => {
      const key = statusQuantityAlias(id)?.id ?? upper(id), held = definition(key);
      if (carrierIds.has(key) && !checkedCarriers.has(key)) {
        checkedCarriers.add(key);
        if (!held || referencedDefinitionIds(held).some(ref => !fullDefinition(definition(ref), 'any'))) {
          dueCarriers.add(key);
          throw new GmBoundaryInputsPending(key);
        }
      }
      return held;
    };
    const read = dryRun ? pinned(live) : live;
    const ctx = paoeEntryContext(boundaryEncounter, members, read, roll,
      synchronousInputs ? () => frameCopyOnRead(boundaryEncounter, members, { catalogs: 'share' })
        : actorId === encounterId ? () => frameCopyOnRead(boundaryEncounter, members) : undefined);
    ctx.saveBoundaryInventory = true;
    ctx.saveObjectDamage = true;
    ctx.objectDamage = [];
    ctx.dryRun = dryRun;
    const verdict = dryRun ? withQuietUnported(() => operation(ctx))
      : reportedSkipReasons?.size ? withQuietUnported(() => operation(ctx), reportedSkipReasons) : operation(ctx);
    // Preload failure alone does not prove an effect was due. Resolvers log the actual skipped duty;
    // adding a generic skip to every dry pattern also defeated the draw-free shortcut.
    if (!dryRun && reportWarmingProblems && warmingProblems.length) console.warn('[gm-boundary] input hydration incomplete', warmingProblems);
    if (!dryRun && ctx.fortunateOffers?.size) verdict.fortunateOffers = [...ctx.fortunateOffers];
    return verdict;
  };
  let tape: RecordedDraw[] = [];
  for (;;) {
    let actual: ReturnType<typeof recordingRollSource> | undefined;
    try {
      const verdict = await resumeDeathResources(() => {
        // gm-dry-run.ts: a clean, draw-free pattern stands for all nine.
        exploreDryPatterns(roll => {
          const verdict = run(roll, true);
          // A nested compiler may catch pending and return a provisional skip.
          const due = [...dueCarriers].find(id => !requestedCarriers.has(id));
          if (due) throw new GmBoundaryInputsPending(due);
          return verdict;
        }, () => consent.pending().length);
        if (!consent.final && consent.pending().length) return null;
        // Consent, inventory facts and death inputs all retain the same draw prefix.
        actual = recordingRollSource(tapedRollSource(tape, browserRollSource()));
        return run(actual);
      }, () => { if (actual) tape = actual.draws; }, deathResources);
      if (!verdict) { await askTriggerConsent(encounterId, actorId, consent); continue; }
      if (await hydrateDueCarriers()) { if (actual) tape = actual.draws; continue; }
      return verdict;
    }
    catch (error) {
      if (actual) tape = actual.draws;
      if (await hydrateDueCarriers()) continue;
      if (error instanceof InventoryDamageFactsNeeded) {
        const needs = error.needs.filter(need => !fetchedFacts.has(`${need.kind}:${need.id}`));
        const hydrated = needs.length && await hydrateInventoryDamageNeeds(needs,
          ids => inventoryFacts.ftAbilityDamageLinkFacts?.(boundaryEncounter, actorId, ids) ?? Promise.resolve(false),
          async id => {
            try {
              await fetchAndCacheCaster(id, { skipEncounterSeed: true, throwOnError: true, participantDeadline: true });
              const fresh = record(window.FateTide?.casterCache?.get(id));
              if (!fresh) return 'corpse-not-held';
              const members = membersOf(boundaryEncounter);
              members.set(id, fresh);
              boundaryEncounter = retainHeldBase(boundaryEncounter, { ...boundaryEncounter, encounter_creatures_arr: [...members.values()] });
              return null;
            } catch { return 'corpse-hydration-unavailable'; }
          }, id => hydrateInventoryObjectVitality(() => boundaryEncounter, id,
            abilityTruthReaders(caster, boundaryEncounter, completeIds(membersOf(boundaryEncounter))).definition,
            readObjectVitalityFact));
        if (hydrated) {
          for (const need of needs) fetchedFacts.add(`${need.kind}:${need.id}`);
          continue;
        }
      }
      if (error instanceof HandBack && error.reason.includes(TRIGGER_CONSENT_REASON) && !consent.final) {
        await askTriggerConsent(encounterId, actorId, consent); continue;
      }
      throw error;
    }
  }
}

/** Room writers receive row-scoped native consequences, just as they receive birth plans.
 * Kept generated rows never install their hypothetical retirement. No save or held-state write here. */
export async function planRoomInventoryRetirements(encounterId: string, ids: readonly string[]): Promise<Record<string, GmBoundaryVerdict>> {
  if (!ids.length) return {};
  const eid = upper(encounterId);
  return withAsyncDeadline(async () => {
    await withAsyncDeadline(() => recoverySettles.get(eid) ?? boundarySettle.pending(eid) ?? Promise.resolve(), 15000);
    const encounter = record(actorEncounterFor(eid));
    if (!encounter) throw new HandBack('room-retirement:encounter-not-held');
    const plans: Record<string, GmBoundaryVerdict> = {};
    for (const id of new Set(ids.map(upper))) {
      const plan = await resolve(eid, eid, encounter,
        ctx => planInventoryDelete(ctx, id, false), [], true, true, false, undefined, true);
      if (plan.inventory?.length || plan.recovery || plan.spawnRows || plan.shapeshiftInventory?.length
        || plan.rows.some(row => row.roll_type_1 === 'janus_unported_skip'))
        throw new HandBack('room-retirement:follow-up-persistence-not-ported');
      plans[id] = plan;
    }
    return plans;
  }, 20000).catch(error => {
    if (error instanceof DOMException && error.name === 'TimeoutError') throw new HandBack('room-retirement:planning-timeout');
    throw error;
  });
}
Object.assign(window, { ftPlanRoomInventoryRetirements: planRoomInventoryRetirements });

/** Timed equipment reuses status removal, including hydration, optional-trigger consent and recorded rolls. No save here. */
export function planTimedEquipStatusRemoval(encounterId: string, actorId: string, encounter: Row, status: Row): Promise<GmBoundaryVerdict> {
  return resolve(encounterId, actorId, encounter, ctx => {
    resolveGmZoneExit(ctx, { statusId: upper(status.status_id), itemId: statusItemId(status), targetId: actorId });
    return boundaryVerdict(ctx);
  }, [statusItemId(status)], false, false, true);
}
Object.assign(window, { ftPlanTimedEquipStatusRemoval: planTimedEquipStatusRemoval,
  ftTimedEquipStatusRemovalCommitted: (eid: string, aid: string, verdict: GmBoundaryVerdict) => {
    if (verdict.fortunateOffers?.length) offerFortunate(eid, aid, verdict.fortunateOffers);
  } });

/** Publish only consequences of the carriers the room transaction actually retired. */
export function roomInventoryRetirementFrame(identity: AppliedFrameIdentity, plans: Record<string, GmBoundaryVerdict>, retired: readonly string[]): AppliedFrameResult | undefined {
  const selected = retired.flatMap(id => plans[id] ? [plans[id]!] : []);
  if (!selected.length) return;
  const encounter = record(actorEncounterFor(identity.encounter_id));
  if (!encounter) throw new Error('room-retirement:encounter-not-held');
  const verdict: GmBoundaryVerdict = { rows: [], ec: {}, statusesAdded: [], statusesRemoved: [], statusStacks: [],
    charges: [], chargesRemoved: [], playerCharactersChanged: [] };
  const removed = new Set<string>();
  for (const plan of selected) {
    verdict.rows.push(...plan.rows);
    for (const [id, columns] of Object.entries(plan.ec)) Object.assign(verdict.ec[id] ??= {}, columns);
    verdict.statusesAdded.push(...plan.statusesAdded);
    verdict.statusStacks.push(...plan.statusStacks);
    verdict.charges.push(...plan.charges);
    verdict.chargesRemoved!.push(...plan.chargesRemoved ?? []);
    verdict.playerCharactersChanged.push(...plan.playerCharactersChanged);
    for (const status of plan.statusesRemoved) {
      const id = upper(status.status_id);
      if (!id || !removed.has(id)) { if (id) removed.add(id); verdict.statusesRemoved.push(status); }
    }
  }
  const read = abilityTruthReaders(encounter, encounter, completeIds(membersOf(encounter)));
  return gmStatusAppliedFrame(identity, verdict, encounter, record(encounter.campaign_arr), read.definition);
}
Object.assign(window, { ftRoomInventoryRetirementFrame: roomInventoryRetirementFrame });

/** Sheet bundles share the websocket planner's hydration, readers and optional-trigger consent. */
async function planPreparedListSwitch(casterId: string, list: number, classNumber: number, caster: Row, encounterId: string): Promise<SpellListSwitchPlan> {
  const held = record(actorEncounterFor(encounterId));
  const encounter = held ? { ...held, encounter_creatures_arr: normalizePhpListish(held.encounter_creatures_arr).map(row => ecId(record(row)) === casterId ? caster : row) }
    : { encounter_creatures_arr: [caster] };
  const read = abilityTruthReaders(caster, encounter, completeIds(membersOf(encounter)));
  const gate = spellListSwitchGate({ encounter, read }, caster);
  if (!gate.ok) throw new Refusal(gate.message);
  if (!spellPrepHasCampaign(caster, encounter))
    return planSpellListSwitch(paoeEntryContext(encounter, membersOf(encounter), read, browserRollSource()), casterId, list, classNumber);
  return resolve(encounterId, casterId, encounter, ctx => {
    // C5 owns death, summon and concentration-summon persistence. Keep this lane's
    // existing named refusals until that complete lifecycle lands.
    delete ctx.deathTail;
    delete ctx.concentrationBreaks;
    return planSpellListSwitch(ctx, casterId, list, classNumber);
  }, [ARCANE_FATIGUE_ID], false, false);
}
Object.assign(window, { ftPlanSpellListSwitch: planPreparedListSwitch,
  ftSpellListSwitchCommitted: (eid: string, aid: string, plan: SpellListSwitchPlan) => {
    if (plan.fortunateOffers?.length) offerFortunate(eid, aid, plan.fortunateOffers);
  } });

/** The offer bundle uses this bridge; the shared boundary lane owns hydration, consent and pre-draw checks. */
export async function planTeleportOfferLanding(encounterId: string, actorId: string,
  point: { x: number; y: number; z: number }, rangeFt: number): Promise<GmBoundaryVerdict> {
  await waitForActorMovement(encounterId, actorId);
  const encounter = actorEncounterFor(encounterId);
  const movement = window.ftMovementDispatchContext?.(encounterId);
  if (!encounter || !movement) throw new HandBack('teleport-offer:encounter-not-held');
  const originals = membersOf(encounter), original = originals.get(upper(actorId));
  const revision = original ? Number(ecLean(original, 'movement_rev') ?? 0) : 0;
  // Landing witnesses guard hydration/consent. Each engine run creates its own
  // synchronous field views; no mutable working frame survives a suspension.
  const statusFacts = (row: Row): unknown[] => Object.values(readCreatureStatuses(row)).map(status => {
    const held = record(status) ?? {};
    return Object.keys(held).filter(key => key.startsWith('status_') && key !== 'status_arr').sort()
      .map(key => [key, statusScalar(held, key)]);
  });
  const facts = (held: Row): string => {
    const page = window.ftMovementDispatchContext?.(encounterId)?.read;
    return JSON.stringify([
      ['encounter_shape', 'encounter_inside', 'in_combat', 'active_combat_id', 'current_round',
        'current_encounter_creature_id_turn', 'turn_phase'].map(key => encounterField(held, key) ?? null),
      page?.crossingWorld?.(),
      statusFacts(held),
      normalizePhpListish(held.encounter_creatures_arr).map(record).filter((row): row is Row => !!row)
        .map(row => [ecId(row), Number(ecLean(row, 'movement_rev') ?? 0), page?.position(row), page?.geometry(row), statusFacts(row)]),
      normalizePhpListish(held.encounter_inventories_arr).map(record).filter((row): row is Row => !!row)
        .map(row => [inventoryField(row, 'inventory_id'), inventoryField(row, 'inventory_deleted') ?? 0,
          inventoryField(row, 'inventory_item_id'), inventoryField(row, 'inventory_generation'), statusFacts(row)]),
    ]);
  };
  const expected = facts(encounter);
  const definitions = new Map<string, Row>();
  const check = (): void => {
    const current = actorRowFor(encounterId, actorId);
    if (!current || Number(ecLean(current as unknown as Row, 'movement_rev') ?? 0) !== revision)
      throw new HandBack('teleport-offer:actor-moved-during-planning');
    const held = actorEncounterFor(encounterId);
    if (!held || held !== encounter || facts(held) !== expected)
      throw new Refusal('The creatures or landing geometry changed while this teleport was being prepared. Choose the destination again.');
    const read = abilityTruthReaders(current as unknown as Row, held, completeIds(membersOf(held)));
    for (const [id, definition] of definitions) if (read.definition(id) !== definition)
      throw new Refusal('A teleport effect changed while this teleport was being prepared. Choose the destination again.');
  };
  const entries = zoneSources(encounter).length ? await hydratePaoeEntryRecords(encounter, actorId, onlySurfaceEntryZones(encounter)) : undefined;
  // Best effort before dry runs: clear landings need no carrier; displaced ones name an unavailable definition.
  try { await fetchAndCacheObject(TELEPORT_DISPLACEMENT_ID); } catch { /* The landing resolver names it only when due. */ }
  check();
  const verdict = await resolve(encounterId, upper(actorId), encounter, ctx => {
    check();
    const definition = ctx.read.definition;
    ctx.read.definition = id => {
      const held = definition(id);
      if (held) definitions.set(id, held);
      return held;
    };
    return resolveTeleportOfferLanding(ctx, actorId, point, rangeFt, movement.read,
      (before, after, id) => {
        const plan = planGmRelocationZones(before, after, id, false, ctx.read.definition);
        if (plan.kind === 'handback') return plan;
        return plan.entries.length || plan.covered.length ? { kind: 'entries', entries: plan.entries, strips: plan.strips, covered: plan.covered }
          : plan.strips.length ? { kind: 'exits', strips: plan.strips } : { kind: 'clear' };
      }, entries);
  }, [...zoneSources(encounter).filter(status => !isSelfStatusOrigin(upper(statusScalar(status, 'status_id')), upper(statusScalar(status, 'status_origin_id'))))
      .map(status => upper(statusScalar(status, 'status_origin_id')) || statusItemId(status)),
      '75682F12-AB67-401B-97D7-F1B7354333CA', 'B45813FE-321A-EC7F-F008-12B8FD33B524'], true, true, 'lazy', undefined, true);
  check();
  verdict.memberExpectedRevs = Object.fromEntries(Object.keys(verdict.ec).map(id => [id, Number(ecLean(originals.get(id) ?? {}, 'movement_rev') ?? 0)]));
  if (entries?.surface_entry_log_receipt)
    (verdict as GmBoundaryVerdict & { surface_entry_log_receipt: 'no-prior-check-this-turn' }).surface_entry_log_receipt = entries.surface_entry_log_receipt;
  return verdict;
}
Object.assign(window, { ftPlanTeleportOfferLanding: planTeleportOfferLanding,
  ftTeleportOfferLandingCommitted: async (encounterId: string, verdict: GmBoundaryVerdict, offerId?: string, actorId?: string) => {
    const encounter = record(actorEncounterFor(encounterId));
    if (!encounter) return;
    adoptPaoeEntryRecords(encounter, verdict.rows);
    if (offerId && actorId && window.ftPushAppliedTruth) {
      const members = new Map((Array.isArray(encounter.encounter_creatures_arr) ? encounter.encounter_creatures_arr as Row[] : []).map(member => [ecId(member), member]));
      const snapshot = frameCopyOnRead(encounter, members, { catalogs: 'share' }).encounter;
      const read = abilityTruthReaders(members.get(actorId) ?? {}, encounter, completeIds(members));
      const frame = gmStatusAppliedFrame({ operation_id: offerId, encounter_id: encounterId, actor_id: actorId,
        rev: Number(verdict.memberExpectedRevs?.[actorId] ?? ecLean(members.get(actorId) ?? {}, 'movement_rev') ?? 0) + 1, member_revs: {} },
        verdict, snapshot, abilityTruthCampaign(encounter), read.definition,
        (member, roster) => possessorSceneContext(encounter, member, roster));
      if ('cache_ref' in frame) throw new Error('teleport-offer:publication-frame-unavailable');
      await window.ftPushAppliedTruth({ type: 'janus_status_truth', command: { operation_id: offerId, encounter_id: encounterId,
        actor_id: actorId, gm_boundary: verdict }, applied_frame: { ...frame,
          inputs: { ...frame.inputs, teleport_offer_resolved: { encounter_id: encounterId, caster_id: actorId, offer_id: offerId } } } });
    }
  } });

/** Only this raw-save endpoint receives GM boundary verdicts; no legacy route or server effect resolver. */
async function save(encounterId: string, actorId: string, kind: string, verdict: GmBoundaryVerdict, operationId = crypto.randomUUID().toUpperCase(), expectedRev?: number, authority: Row = {}, reportFailure = true, onStale?: (error: string) => void): Promise<'handled' | 'refused'> {
  const actor = actorRowFor(encounterId, actorId);
  const applied_frame = appliedStatuses.get(verdict);
  const body = { schema: verdict.spawnRows ? 'janus.status.truth.v2' : 'janus.status.truth.v1', encounter_id: encounterId, actor_id: actorId, operation_id: operationId,
    expected_rev: expectedRev ?? (actor ? Number(ecLean(actor as unknown as Row, 'movement_rev') ?? 0) : 0), kind, gm_boundary: verdict, ...authority };
  const localInstall = applied_frame && window.ftPushAppliedTruth?.({ type: 'janus_status_truth', command: { ...body, schema: 'janus.status.truth.v1', rev: applied_frame.rev }, applied_frame });
  // A transport retry sends the identical verdict/operation; it never draws again.
  const deadline = Date.now() + 30000;
  for (let attempt = 0; attempt < 3; attempt++) {
    const remaining = deadline - Date.now();
    if (remaining <= 0) break;
    try {
      const response = await saveAppliedTruth('/options/game/actions/status_truth_commit_inc.php', body, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body), signal: AbortSignal.timeout(Math.min(10000, remaining)) });
      const result = record(await response.json());
      if (response.ok && result?.ok === true) {
        rememberPaoeEntryLogRows(verdict.rows, encounterId, '', record(verdict)?.surface_entry_time);
        // Encounter-clock decisions have no actor revision. Their applied frame
        // already installs the diff; a synthetic-actor settle would refetch it all.
        // A deletion banks the installed frame's tombstone. The saver may bump
        // its counter again, but no surviving actor row needs that later revision.
        const installRev = applied_frame && !('cache_ref' in applied_frame)
          && applied_frame.deletes.some(row => row.table === 'encounter_creatures' && upper(row.row_id) === actorId)
          ? applied_frame.member_revs[actorId] ?? Number(result.rev) : Number(result.rev);
        const settled = applied_frame && actorId === encounterId ? Promise.resolve(localInstall)
          : settleGmBoundary(encounterId, { actorId, rev: installRev }, verdict);
        if (verdict.recovery || applied_frame && actorId === encounterId) await settled;
        if (verdict.fortunateOffers?.length) offerFortunate(encounterId, actorId, verdict.fortunateOffers);
        await localInstall;
        return 'handled';
      }
      if (response.status >= 500) continue;
      const error = String(result?.error ?? response.status);
      if (response.status === 409 && (error === 'stale' || error.startsWith('stale:'))) {
        // The save's revision / before-state guards refuse inside its transaction, before any write. Install the saved state for the next try.
        onStale?.(error);
        const recovered = settleGmBoundary(encounterId);
        console.warn('[gm-boundary] save refused', error);
        if (onStale) await recovered;
        else if (reportFailure) window.displayWarning?.('The change was not saved: the encounter changed while it was being decided. Refreshing it now — try again in a moment.');
        return 'refused';
      }
      if(reportFailure)refuseUnported(`gm-boundary:save:${error}`, undefined, undefined, 'gm-boundary:save-refused'); return 'refused';
    } catch { /* repeat the same save, never the effect resolution */ }
  }
  if(reportFailure)refuseUnported(`gm-boundary:save-unconfirmed:${operationId}`);
  return 'refused';
}

/** Cover movement/removal reuses native status loss, optional triggers and the existing diff save. */
export function planObjectHunkerEnds(encounterId: string, actorId: string, objectIds: readonly string[]): Promise<GmBoundaryVerdict> {
  const encounter = actorEncounterFor(encounterId);
  if (!encounter) throw new HandBack('hunker:encounter-not-held');
  return resolve(encounterId, actorId, encounter, ctx => {
    for (const removal of brokenObjectHunkers(encounter, new Set(objectIds.map(upper))))
      resolveGmBoundary(ctx, { kind: 'delete', targetId: removal.target, statusId: removal.status_id!, scope: 'single', logCasterId: actorId });
    return boundaryVerdict(ctx);
  }, [HUNKER_STATUS], false, false, false, undefined, true);
}

/** Player-decided status/link and compound object updates share the existing actor-gated raw saver. */
export async function commitLatchVerdict(encounterId: string, actorId: string, verdict: GmBoundaryVerdict, expectedRev: number): Promise<'handled' | 'refused'> {
  const result = await save(encounterId, actorId, 'gm_relocation', verdict, undefined, expectedRev,
    { member_expected_revs: verdict.memberExpectedRevs ?? {} });
  if (result === 'handled') await settledGmBoundary(encounterId);
  return result;
}

export function commitGmSkip(encounterId: string, actorId: string, reason: string, expectedRev?: number, reportFailure = true): Promise<'handled' | 'refused'> {
  return oneAtATime(encounterId, async () => {
    const result = await save(encounterId, actorId, 'gm_relocation', { rows: [skipUnported(reason)], ec: {}, statusesAdded: [], statusesRemoved: [],
      statusStacks: [], charges: [], playerCharactersChanged: [] },crypto.randomUUID().toUpperCase(),expectedRev, {}, reportFailure);
    if (result === 'handled') await settledGmBoundary(encounterId);
    return result;
  });
}

/** Ordinary floor Delete plans every linked removal before publishing or saving. */
export function tryDeleteInventory(input: { encounterId: string; actorId: string; inventoryId: string; log: boolean }): Promise<'handled' | 'refused'> {
  const eid = upper(input.encounterId), aid = upper(input.actorId) || eid;
  return oneAtATime(eid, async () => {
    try {
      await withAsyncDeadline(() => recoverySettles.get(eid) ?? boundarySettle.pending(eid) ?? Promise.resolve(), 15000);
      await withAsyncDeadline(() => waitForActorMovement(eid, aid), 15000);
      const encounter = record(actorEncounterFor(eid));
      if (!encounter) throw new HandBack('inventory-delete:encounter-not-held');
      const members = membersOf(encounter), actor = members.get(aid);
      if (aid !== eid && !actor) throw new HandBack('inventory-delete:actor-not-held');
      const expectedRev = actor ? Number(ecLean(actor, 'movement_rev') ?? 0) : 0;
      // resolve() may still be warming an input after a caller gives up. Fence
      // it before any projection/publish/save, and release the queue on timeout.
      const verdict = await withAsyncDeadline(() => resolve(eid, aid, encounter,
        ctx => planInventoryDelete(ctx, input.inventoryId, input.log), [], true, true, false, undefined, true), 20000);
      const operationId = crypto.randomUUID().toUpperCase();
      const read = abilityTruthReaders(actor ?? {}, encounter, completeIds(members));
      const projection = frameCopyOnRead(encounter, members, { catalogs: 'share' }).encounter;
      appliedStatuses.set(verdict, gmStatusAppliedFrame({ operation_id: operationId, encounter_id: eid, actor_id: aid,
        rev: expectedRev + 1, member_revs: {} }, verdict, projection, abilityTruthCampaign(encounter), read.definition,
        (member, roster) => possessorSceneContext(encounter, member, roster)));
      const targets = inventoryStatusTargets(encounter, verdict.statusesRemoved);
      const ids = new Set([...Object.keys(verdict.ec), ...verdict.statusesRemoved.map(row => upper(row.target))]
        .filter(id => id !== eid && !targets.includes(id)));
      const member_expected_revs = Object.fromEntries([...ids].map(id => {
        const member = members.get(id);
        if (!member) throw new HandBack('inventory-delete:before-member-not-held');
        return [id, Number(ecLean(member, 'movement_rev') ?? 0)];
      }));
      return await save(eid, aid, 'gm_relocation', verdict, operationId, expectedRev,
        { inventory_status_targets: targets, member_expected_revs });
    } catch (error) {
      reportBoundaryError(error instanceof HandBack ? error : new HandBack(`inventory-delete:planning-unavailable:${String(error)}`), 'inventory-delete');
      return 'refused';
    }
  });
}
Object.assign(window, { ftTryDeleteInventory: tryDeleteInventory });

let inventoryMoveTailsSaveReady = false;
async function requireInventoryMoveTailsSave(): Promise<void> {
  if (inventoryMoveTailsSaveReady) return;
  const response = await fetch('/options/tools/inventory/ft3d/move_draggable_inventory_inc.php?transport_tail_capability=1',
    { credentials: 'same-origin', signal: AbortSignal.timeout(5000) });
  const capability = record(await response.json().catch(() => null));
  if (!response.ok || capability?.schema !== 'ft.inventory-move-tails-capability.v1' || capability.supported !== true)
    throw new HandBack('inventory-move:tail-save-not-ready');
  inventoryMoveTailsSaveReady = true;
}

/** The move bundle calls this bridge before its first mutation/POST. It borrows
 * the same native removal frame as Delete; it never saves a separate tail. */
export async function prepareInventoryMoveTails(input: { encounterId: string; actorId: string; inventoryId: string;
  destination: string; quantity: number; merge: string | null; operationId: string; apAfter: number | null }): Promise<InventoryMoveTails> {
  const eid = upper(input.encounterId), aid = upper(input.actorId);
  await requireInventoryMoveTailsSave();
  await withAsyncDeadline(() => recoverySettles.get(eid) ?? boundarySettle.pending(eid) ?? Promise.resolve(), 15000);
  await withAsyncDeadline(() => waitForActorMovement(eid, aid), 15000);
  const encounter = record(actorEncounterFor(eid));
  if (!encounter) throw new HandBack('inventory-move:encounter-not-held');
  const members = membersOf(encounter), actor = members.get(aid);
  if (aid !== eid && !actor) throw new HandBack('inventory-move:actor-not-held');
  const revisions = Object.fromEntries([...members].map(([id, member]) => [id, Number(ecLean(member, 'movement_rev') ?? 0)]));
  let tails: InventoryMoveTails | undefined;
  const verdict = await withAsyncDeadline(() => resolve(eid, aid, encounter, ctx => {
    tails = planInventoryMoveTails(ctx, input.inventoryId, input.destination, input.quantity, input.merge);
    // The single move transaction also saves this already-decided AP column.
    if (actor && input.apAfter !== null) (tails.verdict.ec[aid] ??= {}).aps = input.apAfter;
    return tails.verdict;
  }, [], true, true, false, undefined, true), 20000);
  if (!tails) throw new HandBack('inventory-move:tails-unavailable');
  const targets = new Set([...Object.keys(verdict.ec), ...verdict.statusesRemoved.map(row => upper(row.target)),
    ...verdict.statusesAdded.map(row => upper(row.target)), ...(verdict.chargesRemoved ?? []).map(row => upper(row.holder))]);
  const memberExpectedRevs = Object.fromEntries([...targets].filter(id => members.has(id)).map(id => [id, revisions[id]!]));
  for (const [id, revision] of Object.entries(memberExpectedRevs))
    if (Number(ecLean(membersOf(encounter).get(id) ?? {}, 'movement_rev') ?? 0) !== revision)
      throw new HandBack('inventory-move:member-changed-during-planning');
  const read = abilityTruthReaders(actor ?? {}, encounter, completeIds(members));
  const projection = frameCopyOnRead(encounter, members, { catalogs: 'share' }).encounter;
  // The raw saver increments every changed creature, including a rider other
  // than the picker. Publish the resulting peer revisions with that same diff.
  const projectedMembers = membersOf(projection);
  for (const id of Object.keys(verdict.ec)) if (id !== aid) {
    const peer = record(projectedMembers.get(id)?.encounter_creatures);
    if (peer) peer.movement_rev = (revisions[id] ?? 0) + 1;
  }
  const inventoryChargeDeletes = retireMemberChargePools([...heldInventoryRows({ encounter: projection, members: projectedMembers }).values()], verdict.chargesRemoved ?? []);
  let appliedFrame = gmStatusAppliedFrame({ operation_id: input.operationId, encounter_id: eid, actor_id: aid,
    rev: (revisions[aid] ?? 0) + 1, member_revs: {} }, verdict, projection, abilityTruthCampaign(encounter), read.definition,
    (member, roster) => possessorSceneContext(encounter, member, roster));
  if (!('cache_ref' in appliedFrame)) appliedFrame = { ...appliedFrame, deletes: [...appliedFrame.deletes, ...inventoryChargeDeletes] };
  return { before: tails.before, verdict, memberExpectedRevs, appliedFrame };
}
Object.assign(window, { ftPlanInventoryMoveTails: prepareInventoryMoveTails });

/** Inventory authoring shares native applicability; it has no gain/loss gameplay dispatch. */
export async function planGmInventoryAdd(encounterId: string, actorId: string, inventoryId: string, itemId: string,
  durationInt: unknown, durationType: string, casterId?: string): Promise<GmBoundaryVerdict> {
  const encounter = record(actorEncounterFor(encounterId));
  if (!encounter) throw new HandBack('item-status:encounter-not-held');
  return resolve(encounterId, actorId, encounter, ctx => {
    const target = heldInventoryRows(ctx).get(upper(inventoryId));
    const definition = ctx.read.definition(upper(itemId));
    if (!target) throw new Refusal('The item status was not added: its object is no longer held.');
    if (!definition) throw new Refusal('The item status was not added: its definition could not be loaded.');
    if (!statusApplicableToTarget(ctx.read, upper(itemId), definition, target))
      throw new Refusal('The item status was not added: this status cannot be applied to this object.');
    const duration = { duration_int: String(durationInt ?? ''), duration_type: durationType };
    const original = ctx.read;
    ctx.read = { ...original, value: (row, key) => row === duration ? duration[key as keyof typeof duration] ?? null : original.value(row, key),
      has: (row, key) => row === duration ? key in duration : original.has(row, key) };
    const ends = getStatusEffectDurationTimes(ctx, duration, ctx.members.get(actorId) ?? {});
    ctx.read = original;
    ctx.statusesAdded.push({ status_id: ctx.read.uuid(), status_item_id: itemId, target: inventoryId, caster: upper(casterId) || inventoryId,
      status_connected_id: ctx.read.uuid(), status_stack: 1, ends: ends.ends,
      status_ends_on_target_start_of_turn: ends.flags[0], status_ends_on_target_end_of_turn: ends.flags[1],
      status_ends_on_caster_start_of_next_turn: ends.flags[2], status_ends_on_caster_end_of_next_turn: ends.flags[3] });
    return boundaryVerdict(ctx);
  }, [upper(itemId)]);
}

export function commitGmBoundary(encounterId: string, actorId: string, action: GmBoundaryAction, reportFailure = true,
  stillCurrent?: () => boolean, onStale?: () => void): Promise<'handled' | 'refused'> {
  return oneAtATime(encounterId, () => commitGmBoundaryNow(encounterId, actorId, action, reportFailure, stillCurrent, onStale));
}

/** The row loader hydrates only absent inputs; all tools then join the encounter's saved-row queue. */
async function creatureBoundaryContext(actorId: string, encounterHint?: string): Promise<{ id: string; eid: string; actor: Row }> {
  const where = await ensureActorRowHeld(actorId, encounterHint, { allowRowOnly: true });
  if (where.kind === 'refused') throw new Refusal(where.message);
  return { id: where.actorId, eid: where.encounterId, actor: where.row };
}
function creatureBoundaryEncounter(eid: string, actor: Row): Row {
  if (!eid) actor = record(window.FateTide?.casterCache?.get(ecId(actor))) ?? actor;
  const encounter = eid ? record(actorEncounterFor(eid)) : {
    encounter_master_parent_id: upper(readPlayerCharacterField(actor, 'attached_campaign_id')), encounter_creatures_arr: [actor],
  };
  if (!encounter) throw new HandBack('creature-visibility:encounter-not-held');
  return encounter;
}

/** One applied receipt, including saved status identities, for form/selection visibility and creature departure.
 * Standalone PCs and catalog deletion retain their typed row saver, which returns no revision. */
async function saveCreatureDiff(eid: string, id: string, encounter: Row, verdict: GmBoundaryVerdict,
  expectedRev: number, kind: 'visibility' | 'delete' | 'player_character_delete', hidden?: boolean, authority: Row = {}): Promise<'handled' | 'refused'> {
  // The standalone saver does not bump a revision for an empty verdict.
  if (kind === 'visibility' && !Object.values(verdict).some(value => value && (Array.isArray(value)
    ? value.length : typeof value === 'object' ? Object.keys(value).length : true))) return 'handled';
  const operationId = crypto.randomUUID().toUpperCase();
  const inputs = frameCopyOnRead(encounter, membersOf(encounter), { catalogs: 'share' });
  const read = abilityTruthReaders(inputs.members.get(id) ?? {}, encounter, completeIds(membersOf(encounter)));
  const frame = gmStatusAppliedFrame({ operation_id: operationId, encounter_id: eid || id, actor_id: id,
    rev: expectedRev + 1, member_revs: {} }, verdict, inputs.encounter, abilityTruthCampaign(encounter), read.definition,
    (member, roster) => possessorSceneContext(encounter, member, roster));
  if (eid && kind !== 'player_character_delete') {
    appliedStatuses.set(verdict, frame);
    let recovered = false;
    const outcome = await save(eid, id, 'gm_relocation', verdict, operationId, expectedRev, authority, true, () => { recovered = true; });
    if (outcome === 'handled') await settledGmBoundary(eid);
    else if (!recovered) await settleGmBoundary(eid);
    return outcome;
  }
  const { fortunateOffers, ...saved } = verdict;
  const deleting = kind !== 'visibility';
  const endpoint = deleting ? '/options/game/actions/status_truth_commit_inc.php'
    : `/options/tools/encounter_creatures/${hidden ? 'hide' : 'reveal'}_encounter_creature.php`;
  const body = deleting ? { schema: 'janus.status.truth.v2', kind: kind === 'delete' ? 'creature_delete' : kind,
    actor_id: id, encounter_id: eid, operation_id: operationId, expected_rev: expectedRev, gm_boundary: saved }
    : { encounter_creature_id: id, expected_rev: expectedRev, verdict: saved };
  const init = {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: AbortSignal.timeout(30000),
    body: JSON.stringify(body),
  };
  let response: Response;
  const browserApplied = deleting && !!eid && !!window.ftPushAppliedTruth;
  let localInstall: void | Promise<void> = undefined;
  if (deleting && eid) {
    localInstall = window.ftPushAppliedTruth?.({ type: 'janus_status_truth', command: { ...body, operation_id: operationId,
      encounter_id: eid, actor_id: id, rev: expectedRev + 1 }, applied_frame: frame });
    response = await saveAppliedTruth(endpoint, { operation_id: operationId }, init);
  } else {
    // A standalone catalog PC has no encounter subscription to push to.
    response = await fetch(endpoint, init);
  }
  const result = await response.json() as Row;
  if (!response.ok || result.ok !== true) {
    if (eid) await settleGmBoundary(eid);
    else await fetchAndCacheCaster(id, { skipEncounterSeed: true, throwOnError: true });
    throw new Refusal(String(result.error ?? 'The creature change could not be saved.'));
  }
  if (browserApplied) await localInstall;
  else await window.ftApplyBasePatch?.({ type: 'base_patch', encounter_id: eid || id, ops: [], applied: JSON.stringify(frame) });
  if (eid) await settleGmBoundary(eid, { actorId: id, rev: expectedRev + 1 });
  if (fortunateOffers?.length) offerFortunate(eid || id, id, fortunateOffers);
  return 'handled';
}

/** Explicit form direction and the selection tool share hydration, movement wait, resolution and saved-row adoption. */
async function applyVisibilityDiff(targetIds: string[], encounterId?: string, hidden?: boolean, rollPrivate = 0): Promise<'handled' | 'refused'> {
  try {
    const ids = [...new Set(targetIds.map(upper))];
    if (!ids.length) return 'handled';
    const { id, eid, actor } = await creatureBoundaryContext(ids[0]!, encounterId);
    return await oneAtATime(eid || id, async () => {
      for (const targetId of ids) if (eid) await waitForActorMovement(eid, targetId);
      const encounter = creatureBoundaryEncounter(eid, actor), members = membersOf(encounter);
      if (ids.some(targetId => !members.has(targetId))) throw new HandBack('creature-visibility:target-not-held');
      const revisions = Object.fromEntries(ids.map(targetId => [targetId, Number(ecLean(members.get(targetId)!, 'movement_rev') ?? 0)]));
      const verdict = await resolve(eid || id, id, encounter, ctx => hidden === undefined
        ? resolveVisibilitySelection20(ctx, ids, rollPrivate) : resolveCreatureVisibility(ctx, id, hidden),
        [CREATURE_HIDDEN_STATUS], true, false, false, undefined, true);
      return saveCreatureDiff(eid, id, encounter, verdict, revisions[id]!, 'visibility', hidden,
        { member_expected_revs: revisions, roll_private: rollPrivate });
    });
  } catch (error) { reportBoundaryError(error, 'creature-visibility'); return 'refused'; }
}

/** The creature form also serves PCs outside an encounter; those resolve against their own saved row. */
export function tryCommitCreatureVisibility(actorId: string, hidden: boolean): Promise<'handled' | 'refused'> {
  return applyVisibilityDiff([actorId], undefined, hidden);
}
Object.assign(window, { ftTryCommitCreatureVisibility: tryCommitCreatureVisibility });

Object.assign(window, { ftPlanDestructionRemoval: (eid: string, commands: ObjectDestroyCommand[]) => {
  const encounter = record(actorEncounterFor(eid));
  if (!encounter) throw new HandBack('recursive-delete:encounter-not-held');
  const members = membersOf(encounter), caster = members.values().next().value ?? {};
  const read = abilityTruthReaders(caster, encounter, completeIds(members));
  const ctx = paoeEntryContext(encounter, members, read, browserRollSource(), () => frameCopyOnRead(encounter, members, { catalogs: 'share' }));
  const metadata = record(record(encounter._entity_base)?.metadata);
  return planDestructionRemoval(ctx, commands, normalizePhpListish(metadata?.statusCatalog).flatMap(row => record(row) ? [row as Row] : []));
} });

Object.assign(window, { ftPrepareRecursiveDeletion: (url: string, data: Row) => prepareRecursiveDeletion(url, data, {
  encounter: async id => record(actorEncounterFor(id)) ?? campaignToggleEntity(id, 'encounter'),
  resolve: (id, encounter, run, sources) => resolve(id, id, encounter, run, sources, true, true, false, undefined, true),
  report: error => reportBoundaryError(error, 'recursive-delete'),
}) });

/** Catalog PCs and GM encounter deletes use the same native consequence ledger. */
export async function tryDeleteCreature22(actorId: string, deletePlayerCharacter = false): Promise<'handled' | 'refused'> {
  try {
    const { id, eid, actor } = await creatureBoundaryContext(actorId);
    return await oneAtATime(eid || id, async () => {
      if (eid) await waitForActorMovement(eid, id);
      const encounter = creatureBoundaryEncounter(eid, actor), target = membersOf(encounter).get(id)!;
      const expectedRev = Number(ecLean(target, 'movement_rev') ?? 0);
      const verdict = await resolve(eid || id, id, encounter, ctx => {
        composeCreatureDeletion22(ctx, ctx.members.get(id)!);
        if (!deletePlayerCharacter && ecLean(target, 'item_type') !== 'lair') renumberCreatureDeletion22(ctx);
        if (!deletePlayerCharacter && !document.getElementById('modify_encounter_encounter_creature_ids') && abilityTruthCampaign(encounter))
          ctx.rows.push({ roll_type_1: 'creature_deleted', roll_type_2: null, roll_result: 0, roll_item_id: null, roll_by: id, roll_to: null });
        const result = boundaryVerdict(ctx);
        (result.ec[id] ??= {}).encounter_creature_deleted = 1;
        return result;
      }, [], false, false, true, undefined, true);
      const outcome = await saveCreatureDiff(eid, id, encounter, verdict, expectedRev, deletePlayerCharacter ? 'player_character_delete' : 'delete');
      if (outcome === 'handled') (window as Window & { ftCatalogRemoveRow?: (id: string) => void }).ftCatalogRemoveRow?.(id);
      return outcome;
    });
  } catch (error) { reportBoundaryError(error, 'creature-delete'); return 'refused'; }
}
Object.assign(window, { ftTryDeleteCreature22: tryDeleteCreature22 });

/** The solid-movement receiver persists this plan in the position's own transaction. */
async function planMovementStatuses20(encounterId: string, command: MovementStatusInputs20): Promise<GmBoundaryVerdict> {
  const encounter = actorEncounterFor(encounterId);
  if (!encounter) throw new HandBack('movement-status:encounter-not-held');
  return resolve(encounterId, upper(command.actor_id), encounter, ctx => resolveMovementStatusInputs20(ctx, command),
    movementStatusDefinitionIds20(command, membersOf(encounter).get(upper(command.actor_id)), membersOf(encounter)), false, false, 'lazy', undefined, true);
}

/** One confirmed GM selection converges on one direction and saves through the native status receipt. */
async function toggleCreatureVisibility20(encounterId: string, targetIds: string[], rollPrivate = 0): Promise<'handled' | 'refused'> {
  return applyVisibilityDiff(targetIds, encounterId, undefined, rollPrivate);
}
Object.assign(window, { ftPlanMovementStatuses20: planMovementStatuses20, ftToggleCreatureVisibility20: toggleCreatureVisibility20 });

/** Install the walk's decided endpoint effects in its existing movement revision and frame. */
export function movementStatusAppliedFrame20(command: import('../janus-engine/movement/client-truth-commit.js').MovementTruthCommand): import('../janus-engine/transport/applied-frame').AppliedFrameResult {
  const encounter = actorEncounterFor(command.encounter_id);
  if (!encounter || !command.status_plan) throw new HandBack('movement-status:encounter-not-held');
  const members = membersOf(encounter), actor = members.get(command.actor_id);
  if (!actor) throw new HandBack('movement-status:actor-not-held');
  const read = abilityTruthReaders(actor, encounter, completeIds(members));
  const ec = { ...command.status_plan.ec };
  for (const member of command.compound?.members ?? []) if (member.id)
    ec[member.id] = { ...ec[member.id], movement_rev: member.expected_rev + 1 };
  return gmStatusAppliedFrame({ operation_id: command.operation_id, encounter_id: command.encounter_id,
    actor_id: command.actor_id, rev: command.expected_rev + 1, member_revs: {} }, { ...command.status_plan, ec }, encounter,
    abilityTruthCampaign(encounter), read.definition, (member, roster) => possessorSceneContext(encounter, member, roster));
}
Object.assign(window, { ftMovementStatusAppliedFrame20: movementStatusAppliedFrame20 });

/** Every GM document holding the encounter (the page and its FT3D scene iframe, other GM tabs) observes the same due anchors, so a stale
 *  answer means another one saved first: no GM-tool warning (the settle resyncs and the next observation re-decides). Three stale answers
 *  in a row name themselves once as telemetry; a saved expiry or no due anchor ends the streak. */
const zoneExpiryStale = new Map<string, number>();
type ZoneExpiryRetry = { signature: string; attempts: number; after: number; logged: Set<string> };
const zoneExpiryRetries = new Map<string, ZoneExpiryRetry>();
/** Observing GM clocks share the GM queue and lazy save; never enqueue another GM commit inside this work item. */
export function commitDueZoneExpiries(encounterId: string, clock: Pick<ExpiryReaders, 'seconds' | 'nowSeconds'>): Promise<'handled' | 'refused' | null> {
  const key = upper(encounterId);
  return oneAtATime(encounterId, async () => {
    let retry: ZoneExpiryRetry | undefined;
    let signature = '';
    const defer = (): ZoneExpiryRetry => {
      const attempts = (retry?.attempts ?? 0) + 1;
      const next = { signature, attempts, after: Date.now() + Math.min(60000, 15000 * 2 ** Math.min(attempts - 1, 2)), logged: retry?.logged ?? new Set<string>() };
      zoneExpiryRetries.set(key, next);
      return next;
    };
    try {
      const encounter = record(actorEncounterFor(encounterId));
      if (!encounter) { zoneExpiryRetries.delete(key); zoneExpiryStale.delete(key); return null; }
      const members = membersOf(encounter);
      const ctx = { encounter, members, read: { value: ftLayerValue, statuses: (row: Row) => ftCreatureStatuses(row, 'target') as Row[] } };
      const due = dueCascadeSources(ctx, clock);
      if (!due.length) { zoneExpiryStale.delete(key); zoneExpiryRetries.delete(key); return null; }
      const epoch = (globalThis as unknown as { __ftDefinitionStore?: { epoch?: number | null; cacheGeneration?: number } }).__ftDefinitionStore;
      signature = JSON.stringify([epoch?.epoch, epoch?.cacheGeneration, due.map(({ holder, status }) => [holder,
        ...['status_id', 'status_item_id', 'status_origin_id', 'status_connected_id', 'status_t_updated', 'status_stack',
          ...['year', 'month', 'day', 'hour', 'minute', 'second'].map(part => `status_ends_campaign_${part}`)]
          .map(field => statusScalar(status, field))])]);
      retry = zoneExpiryRetries.get(key);
      if (retry?.signature !== signature) { zoneExpiryRetries.delete(key); retry = undefined; }
      if (retry && Date.now() < retry.after) return null;
      const verdict = await resolve(encounterId, encounterId, encounter, next => resolveDueZoneExpiries(next, clock),
        due.filter(({ status }) => !isSelfStatusOrigin(upper(statusScalar(status, 'status_id')), upper(statusScalar(status, 'status_origin_id'))))
          .map(({ status }) => upper(statusScalar(status, 'status_origin_id')) || statusItemId(status)), false, true, holdsTaggedSummon(encounter), retry?.logged, true);
      const unfinished = due.some(({ status }) => !verdict.statusesRemoved.some(removed => upper(removed.status_id) === upper(statusScalar(status, 'status_id'))));
      const skips = verdict.rows.filter(row => row.roll_type_1 === 'janus_unported_skip').map(row => String(row.rolls_full));
      // Keep a failed anchor pending, with bounded recovery. Its same skipped duty is logged only once while inputs are unchanged.
      verdict.rows = verdict.rows.filter(row => row.roll_type_1 !== 'janus_unported_skip' || !retry?.logged.has(String(row.rolls_full)));
      if (unfinished) retry = defer();
      if (!verdict.rows.length && !Object.keys(verdict.ec).length && !verdict.statusesAdded.length && !verdict.statusesRemoved.length
        && !verdict.statusStacks.length && !verdict.charges.length && !verdict.playerCharactersChanged.length
        && !verdict.chargesRemoved?.length && !verdict.inventory?.length && !verdict.spawnRows && !verdict.recovery && !verdict.fortunateOffers?.length) return null;
      const operationId = crypto.randomUUID().toUpperCase();
      const read = abilityTruthReaders(members.values().next().value ?? {}, encounter, completeIds(members));
      appliedStatuses.set(verdict, gmStatusAppliedFrame({ operation_id: operationId, encounter_id: encounterId,
        actor_id: encounterId, rev: 0, member_revs: {} }, verdict,
        frameCopyOnRead(encounter, members, { catalogs: 'share' }).encounter, abilityTruthCampaign(encounter), read.definition,
        (member, roster) => possessorSceneContext(encounter, member, roster)));
      let stale = false;
      const outcome = await save(encounterId, encounterId, 'gm_relocation', verdict, operationId, 0,
        { inventory_status_targets: inventoryStatusTargets(encounter, verdict.statusesRemoved) }, !retry || retry.attempts === 1, error => {
          stale = true;
          const streak = (zoneExpiryStale.get(key) ?? 0) + 1;
          zoneExpiryStale.set(key, streak);
          if (streak === 3) skipUnported(`zone-expiry:stale-repeat:${error}`, { encounterId: key, statusIds: verdict.statusesRemoved.map(s => s.status_id) });
        });
      if (outcome === 'handled') {
        zoneExpiryStale.delete(key);
        if (unfinished) for (const reason of skips) retry!.logged.add(reason);
        else zoneExpiryRetries.delete(key);
      } else if (!stale && !unfinished) defer();
      return outcome;
    } catch (error) {
      if (!retry) reportBoundaryError(error, 'zone-expiry');
      if (signature) defer();
      return 'refused';
    }
  });
}
function holdsTaggedSummon(encounter: Row): boolean {
  return holdsLiveTaggedSummon(membersOf(encounter).values());
}
/** Bind automatic recovery to this decision without changing the common persistence call. */
function boundarySaver(onStale?: () => void): typeof save {
  return (...args) => { args[8] ??= onStale; return save(...args); };
}
async function commitGmBoundaryNow(encounterId: string, actorId: string, action: GmBoundaryAction, reportFailure: boolean,
  stillCurrent?: () => boolean, onStale?: () => void): Promise<'handled' | 'refused'> {
  const save = boundarySaver(onStale);
  try {
    await waitForActorMovement(encounterId, actorId);
    if (action.kind === 'life' && action.action === 'resurrect') await window.ftWaitForInventoryBase?.(encounterId);
    if (stillCurrent && !stillCurrent()) return 'refused';
    const encounter = actorEncounterFor(encounterId);
    if (!encounter) throw new HandBack('gm-boundary:encounter-not-held');
    const excludePending = (members: ReadonlyMap<string, Row>): void => {
      const target = members.get(upper(action.targetId));
      if (action.kind === 'add' && stillCurrent && target) {
        const saved = withoutEncumbranceApplication(target, upper(action.itemId));
        if (saved !== target) target.statuses = saved.statuses;
      }
    };
    const original = membersOf(encounter).get(actorId);
    const expectedRev = original ? Number(ecLean(original, 'movement_rev') ?? 0) : 0;
    const recoveryRead = action.kind === 'life' && action.action === 'resurrect' && original && Number(ecLean(original, 'encounter_creature_dead') ?? 0) === 1
      ? abilityTruthReaders(original, encounter, completeIds(membersOf(encounter))) : null;
    const recoveryIds = recoveryRead ? recoveryRead.statuses(original!).map(statusItemId)
      .filter(id => [...RECOVERY_STATUS_IDS, '99C862B9-D6AE-4E18-7803-A6F9B42A88E1', 'F5ACBDB4-D923-3684-57F6-FBF3F720AEFA'].includes(id)) : [];
    if (recoveryRead) {
      await hydrateRemovalSupportDefinitions(recoveryRead.statuses(original!), recoveryRead,
        async ids => { await Promise.all(ids.map(id => fetchAndCacheObject(id))); });
    }
    const sourceIds = action.kind === 'add' ? [...(stageRowFamily(action.itemId) ?? [action.itemId])] : recoveryIds;
    if (action.kind === 'delete') {
      const members = membersOf(encounter), target = members.get(upper(action.targetId));
      const read = abilityTruthReaders(original ?? target ?? {}, encounter, completeIds(members));
      const selected = target && read.statuses(target).find(status => upper(read.value(status, 'status_id')) === upper(action.statusId));
      if (selected) {
        const connection = upper(read.value(selected, 'status_connected_id'));
        const removals: Row[] = [];
        if (connection && (action.scope !== 'single' || statusItemId(selected) === STATUS_IDS.concentrating)) {
          for (const member of members.values()) for (const status of read.statuses(member))
            if (upper(read.value(status, 'status_connected_id')) === connection) removals.push(status);
        } else removals.push(selected);
        // resolve() hydrates actual fall carriers on demand; grounded removals need none.
        sourceIds.push(...exactRemovalTailDefinitionIds(removals, read, 'on-demand'));
      }
    }
    // Dead adds and summon-tag removals need the same prepared death package as a life action.
    const deathsDue = action.kind === 'life' ? action.action !== 'resurrect'
      : action.kind === 'add' ? upper(action.itemId) === DEAD_STATUS_ID
        : action.kind === 'delete' && holdsTaggedSummon(encounter);
    const verdict = await resolve(encounterId, actorId, encounter, ctx => { excludePending(ctx.members); return resolveGmBoundary(ctx, action); }, sourceIds,
      false, true, deathsDue, undefined, true, action.kind === 'add' ? action : undefined);
    if (stillCurrent && !stillCurrent()) return 'refused';
    const authority: Row = action.kind === 'delete' ? { status_id: action.statusId, scope: action.scope }
      : action.kind === 'add' ? { roll_private: action.rollPrivate ?? 0 } : {};
    // Zone adds and removals deliver item-held copies through the same raw item patch lane.
    const inventoryTargets = inventoryStatusTargets(encounter, [...verdict.statusesAdded, ...verdict.statusesRemoved]);
    if (inventoryTargets.length) authority.inventory_status_targets = inventoryTargets;
    if (verdict.statusesRemoved.some(s => s.before)) {
      const ids = new Set([...Object.keys(verdict.ec), ...verdict.statusesRemoved.map(s => upper(s.target)).filter(id => !inventoryTargets.includes(id) && id !== upper(encounterId))]);
      Object.assign(authority, { member_expected_revs: Object.fromEntries([...ids].map(id => {
        const member = membersOf(encounter).get(id);
        if (!member) throw new HandBack('gm-boundary:before-member-not-held');
        return [id, Number(ecLean(member, 'movement_rev') ?? 0)];
      })) });
    }
    const operationId = crypto.randomUUID().toUpperCase();
    const read = abilityTruthReaders(original ?? {}, encounter, completeIds(membersOf(encounter)));
    // Projection is synchronous: isolate only fields it touches, after input hydration has settled.
    const projection = frameCopyOnRead(encounter, membersOf(encounter), { catalogs: 'share' }).encounter;
    excludePending(membersOf(projection));
    appliedStatuses.set(verdict, gmStatusAppliedFrame({ operation_id: operationId, encounter_id: encounterId, actor_id: actorId,
      rev: expectedRev + 1, member_revs: {} }, verdict, projection, abilityTruthCampaign(encounter), read.definition,
      (member, roster) => possessorSceneContext(encounter, member, roster)));
    const result = await save(encounterId, actorId, action.kind === 'life' ? `creature_${action.action}` : `status_${action.kind}`, verdict, operationId, expectedRev, authority, reportFailure);
    if (result === 'handled' && reportFailure && action.kind === 'add' && action.logMessage !== false
        && !verdict.statusesAdded.length && !verdict.statusStacks.length
        && verdict.rows.some(row => row.roll_type_1 === 'target_immune_to_status_effect' && row.roll_item_id === upper(action.itemId))) {
      const target = membersOf(encounter).get(upper(action.targetId));
      const name = String(ecLean(target ?? {}, 'encounter_creature_name') ?? itemField(target ?? {}, 'item_name') ?? 'The target');
      const status = String(itemField(read.definition(upper(action.itemId)), 'item_name') ?? 'this status');
      window.displayWarning?.(escapeHtml(`${name} is immune to ${status}`));
    }
    return result;
  } catch (error) {
    if (reportFailure) reportBoundaryError(error, 'gm-boundary');
    return 'refused';
  }
}

/** API placement has completed; resolve only destination membership, then save effects and exact exit rows. */
async function resolveGmRelocationCore(raw: unknown): Promise<void> {
  const facts = record(raw), after = record(facts?.after), positions = record(facts?.before_positions);
  const encounterId = upper(facts?.encounter_id);
  if (!positions || !after || !encounterId) throw new Error('gm-relocation:missing-boundary-snapshot');
  const actingId=upper(facts?.actor_id)||encounterId;
  // Build this field view within each synchronous decision; no encounter snapshot crosses hydration awaits.
  const before = (): Row => {
    const frame = frameCopyOnRead(after, membersOf(after), { catalogs: 'share' });
    for (const [id, value] of Object.entries(positions)) {
      const member = frame.members.get(upper(id)), position = record(value);
      if (member && position) { Object.assign(record(member.encounter_creatures) ?? {}, position); member.position = { ...record(member.position), ...position }; }
    }
    return frame.encounter;
  };
  const moved = normalizePhpListish(facts?.moved_ids).map(upper);
  const squeezeRead = movementScopeReaders(after), runtimeShape = pageSceneShape(after), relocationMembers = membersOf(after);
  if (runtimeShape) squeezeRead.crossingWorld = () => ({ shape: runtimeShape as never,
    canvasExterior: Number(encounterField(after, 'encounter_inside') ?? 0) !== 1, overlayUnknown: false });
  const squeezeChanges = new Map<string, { squeezed: boolean; very: boolean }>();
  const squeezeDefinitions: string[] = [];
  for (const id of moved) {
    const member = relocationMembers.get(id);
    if (!member) continue;
    const [x, y, z] = squeezeRead.position(member), state = squeezeStateAt(after, member, squeezeRead, x, y, z);
    if (!state) throw new Error('gm-relocation:squeeze-geometry');
    if (state.squeezed === squeezeRead.hasStatus(member, 'squeezed') && state.very === squeezeRead.hasStatus(member, 'very_squeezed')) continue;
    squeezeChanges.set(id, state);
    squeezeDefinitions.push(...movementStatusDefinitionIds20({ actor_id: id, updates: { x_pos: x, y_pos: y, z_pos: z }, squeeze: state }, member));
  }
  // Most moves cross no zone: answer that from the page's own definitions before warming every trigger the roster could fire.
  try {
    const campaign = abilityTruthCampaign(after), judged = campaign ? retainHeldBase(after, { ...after, campaign_arr: campaign }) : after;
    const members = membersOf(judged), caster = members.get(actingId) ?? members.values().next().value ?? {};
    if (!squeezeChanges.size && relocationTouchesNoZone(before(), after, moved, facts?.transfer === true, abilityTruthReaders(caster, judged, completeIds(members)).definition)) return;
  } catch { /* judged in full below */ }
  const sourceIds = zoneSources(after).filter(status => !isSelfStatusOrigin(upper(statusScalar(status, 'status_id')), upper(statusScalar(status, 'status_origin_id'))))
    .map(status => upper(statusScalar(status, 'status_origin_id')) || statusItemId(status)).concat(squeezeDefinitions);
  const verdict = await resolve(encounterId, actingId, after, ctx => {
    const previous = before();
    const skipped = new Map<string, Set<string>>();
    const entered = new Set<string>();
    let missingSurfaceLog = false;
    const encounterWide = new Set(['persistent-zone:connectionless', 'persistent-zone:definition-missing', 'persistent-zone:trap',
      'persistent-zone:class-aura-definition', 'persistent-zone:class-aura-size']);
    for (const actorId of moved) {
      const plan = planGmRelocationZones(previous, after, actorId, facts?.transfer === true, ctx.read.definition);
      if (plan.kind === 'handback') {
        const names = skipped.get(plan.reason) ?? new Set<string>(); skipped.set(plan.reason, names);
        if (encounterWide.has(plan.reason)) { moved.forEach(id => names.add(creatureName(ctx, id))); break; }
        names.add(creatureName(ctx, actorId));
        continue;
      }
      for (const entrant of uniqueZoneEntrants([{ actorId, entries: plan.entries }, ...plan.covered], entered)) for (const entry of entrant.entries) {
        const definition = ctx.read.definition(entry.originId);
        const records = hasSurfaceTypeValue(ctx.read, definition) ? readSurfaceEntryRecords(ctx.encounter) : undefined;
        if (records?.surface_entry_log_receipt) missingSurfaceLog = true;
        resolveGmZoneEntry(ctx, { abilityId: entry.originId, casterId: entry.casterId, enteringId: entrant.actorId, statusConnectedId: entry.connectedId, forcedExtreme: entry.forcedExtreme }, records);
      }
      for (const strip of plan.strips) resolveGmZoneExit(ctx, strip);
    }
    for (const [reason, names] of skipped) ctx.rows.push(skipUnported(`gm-relocation:${[...names].join(', ')}:${reason}`));
    for (const [id, state] of squeezeChanges) resolveMovementSqueeze20(ctx, id, state);
    return { ...boundaryVerdict(ctx), ...(missingSurfaceLog ? { surface_entry_log_receipt: 'no-prior-check-this-turn' as const } : {}) };
  }, sourceIds, false, true, holdsTaggedSummon(after), undefined, true);
  if (!verdict.rows.length && !Object.keys(verdict.ec).length && !verdict.statusesAdded.length && !verdict.statusesRemoved.length
    && !verdict.statusStacks.length && !verdict.charges.length && !verdict.playerCharactersChanged.length) return;
  const acting=membersOf(after).get(actingId);
  if (await save(encounterId, actingId, 'gm_relocation', verdict, crypto.randomUUID().toUpperCase(),
    acting?Number(ecLean(acting,'movement_rev')??0):0,{},false) !== 'handled') throw new Error('gm-relocation:effects-save-unconfirmed');
}

export async function resolveGmRelocation(raw: unknown): Promise<void> {
  // The campaign owns the held action state; its scene must not warm a second boundary cache.
  const parent = window.parent as Window & { ftResolveGmRelocation?: (facts: unknown) => Promise<void> };
  if (parent && parent !== window && typeof parent.ftResolveGmRelocation === 'function'
    && parent.document.querySelector<HTMLIFrameElement>('[data-ft3d-encounter-frame]')?.contentWindow === window)
    return parent.ftResolveGmRelocation(raw);
  try { await resolveGmRelocationCore(raw); }
  catch (error) {
    const facts=record(raw),encounterId=upper(facts?.encounter_id),after=record(facts?.after);
    const reason=error instanceof HandBack?error.reason:String(error);
    if (error instanceof Error && error.message === 'gm-relocation:squeeze-geometry')
      window.displayWarning?.('Position saved; the browser could not determine its Squeezed condition (gm-relocation:squeeze-geometry).');
    if(!encounterId || !after) { refuseUnported(`gm-relocation:missing-boundary-snapshot:${reason}`); return; }
    if(encounterId && after && zoneSources(after).length) {
      const moved=new Set(normalizePhpListish(facts?.moved_ids).map(upper));
      const names=[...membersOf(after)].filter(([id])=>moved.has(id)).map(([,row])=>String(ecLean(row,'encounter_creature_name')??record(row.items)?.item_name??'Creature'));
      const actingId=upper(facts?.actor_id)||encounterId,acting=membersOf(after).get(actingId);
      await commitGmSkip(encounterId,actingId,`gm-relocation:${names.join(', ')}:zone-effects-incomplete:${reason}`,
        acting?Number(ecLean(acting,'movement_rev')??0):0);
    }
    // Placement already committed. A boundary effect failure must never report the move as refused.
  }
}

/** Dry classification of actual source-zone exits; ordinary relocation emits no skip row. */
export function previewGmTransferExitEffects(encounters: Row[], removals: {status_id:string;before:Row}[], label='gm-relocation'): string[] {
  const logs=new Set<string>();
  for(const encounter of encounters){
    const members=membersOf(encounter),caster=members.values().next().value;
    if(!caster)continue;
    const read=abilityTruthReaders(caster,encounter,completeIds(members));
    for(const removal of removals){
      const owner=members.get(upper(removal.before.status_target_id));
      if(!owner)continue;
      const ctx=paoeEntryContext(encounter,members,read,payloadDryRunRollSource(PAYLOAD_DRY_PATTERNS[0]!));
      ctx.dryRun=true;
      try{
        resolveGmZoneExit(ctx,{statusId:removal.status_id,itemId:upper(removal.before.status_item_id),targetId:upper(removal.before.status_target_id)});
        const verdict=boundaryVerdict(ctx);
        const skipped=verdict.rows.filter(r=>r.roll_type_1==='janus_unported_skip');
        for(const row of skipped)logs.add(String(row.rolls_full));
        if(verdict.statusesAdded.length||verdict.statusesRemoved.length>1||Object.keys(verdict.ec).length||verdict.charges.length||verdict.statusStacks.length||verdict.playerCharactersChanged.length||verdict.rows.some(r=>r.roll_type_1!=='janus_unported_skip'))
          logs.add(`${label}:${creatureName(ctx,upper(removal.before.status_target_id))}:source-zone-exit-follow-up-effects-not-saved`);
      }catch(error){logs.add(`${label}:${creatureName(ctx,upper(removal.before.status_target_id))}:source-zone-exit:${error instanceof HandBack?error.reason:String(error)}`);}
    }
  }
  return [...logs];
}

/** Transfer preflight shares the compound graph; summons carried by the PHP transport count too. */
export async function prepareGmTransfer(destinationId: string, actorIds: string[]): Promise<boolean> {
  return prepareTransferBoundary(destinationId, actorIds);
}

async function prepareTransferBoundary(destinationId: string, actorIds: string[]): Promise<boolean> {
  try {
    for (const id of actorIds) {
      const where = await ensureActorRowHeld(id, undefined, { what: 'The transfer' });
      if (where.kind !== 'encounter') throw new Refusal(where.kind === 'refused' ? where.message : 'The transfer has no source encounter.');
      if (upper(where.encounterId) === upper(destinationId)) continue;
      await waitForActorMovement(where.encounterId, where.actorId);
      const encounter = record(actorEncounterFor(where.encounterId));
      if (!encounter) throw new HandBack('gm-transfer:source-not-held');
      const members = membersOf(encounter), mover = members.get(upper(id));
      if (!mover) throw new HandBack('gm-transfer:actor-not-held');
      const read = { statuses: (r: Row) => Object.values(readCreatureStatuses(r)).map(record).filter((s): s is Row => s !== null) };
      const group = compoundActorIds(encounter, mover, read);
      let count: number;
      do {
        count = group.size;
        for (const member of members.values()) if (group.has(upper(ecLean(member, 'controller_encounter_creature_id'))))
          for (const companionId of compoundActorIds(encounter, member, read)) group.add(companionId);
      } while (group.size !== count);
      requireEndedTurn(encounter, group, 'transfer');
    }
    return true;
  } catch (error) {
    reportBoundaryError(error, 'gm-transfer');
    return false;
  }
}

export const RELOCATION_ROUTES = new Set([
  'set_campaign_campsite_inc.php',
  'gm_move_targets_to_encounter_inc.php', 'gm_move_creature_cross_encounter_at_grid_inc.php',
  'gm_push_all_to_encounter_inc.php', 'gm_pull_all_creatures_from_encounter_inc.php', 'gm_push_party_to_encounter_inc.php',
  'gm_push_party_to_campaign_campsite_inc.php', 'gm_push_party_to_campaign_stronghold_inc.php',
  'soft_delete_all_locations_except_campaign_campsite_and_campaign_stronghold.php', 'link_player_character_inc.php',
  'accept_campaign_join_request_inc.php', 'bulk_campaign_join_requests_inc.php',
  ...['late', 'not_late', 'no_show', 'show', 'left_early', 'not_left_early'].map(k => `mark_player_character_${k}.php`),
]);

/** Delete only non-haven location scopes; evacuate their PCs, including inactive PCs, before storage removes the rooms.
 * Saved identities suffice for this selection. The native relocation planner loads boundary/compound inputs only for actual movers. */
export function locationCleanupSources(facts: Row): { destinationId: string; actorIds: string[]; focusCampsite: boolean } {
  const campaign = record(facts.campaign);
  if (!campaign || !Array.isArray(facts.locations) || !Array.isArray(facts.encounters) || !Array.isArray(facts.creatures))
    throw new Error('location-cleanup:source-rows-unavailable');
  const destinationId = upper(_ftCamField(campaign, 'campaign_campsite_encounter_id'));
  const havens = new Set([destinationId, upper(_ftCamField(campaign, 'campaign_stronghold_encounter_id'))].filter(Boolean));
  const locations = normalizePhpListish(facts.locations).map(record).filter((row): row is Row => row !== null)
    .filter(row => Number(ftLayerValue(row, 'location_deleted') ?? 0) === 0);
  const encounters = normalizePhpListish(facts.encounters).map(record).filter((row): row is Row => row !== null);
  const protectedLocations = new Set(encounters.filter(row => havens.has(upper(encounterField(row, 'encounter_id'))))
    .map(row => upper(encounterField(row, 'encounter_location_id'))).filter(Boolean));
  let size: number;
  do {
    size = protectedLocations.size;
    for (const row of locations) if (protectedLocations.has(upper(ftLayerValue(row, 'location_parent_id'))))
      protectedLocations.add(upper(ftLayerValue(row, 'location_id')));
  } while (protectedLocations.size !== size);
  const deletedLocations = new Set(locations.filter(row => !protectedLocations.has(upper(ftLayerValue(row, 'location_id')))
    && !['Campaign Campsite', 'Campaign Stronghold'].includes(String(ftLayerValue(row, 'location_name') ?? '')))
    .map(row => upper(ftLayerValue(row, 'location_id'))));
  const deletedRooms = new Set(encounters.filter(row => Number(encounterField(row, 'encounter_deleted') ?? 0) === 0
    && !havens.has(upper(encounterField(row, 'encounter_id')))
    && deletedLocations.has(upper(encounterField(row, 'encounter_location_id')))).map(row => upper(encounterField(row, 'encounter_id'))));
  // Older location rows can themselves hold creatures; the storage cascade clears those residents too.
  const actorIds = normalizePhpListish(facts.creatures).map(record).filter((row): row is Row => row !== null)
    .filter(row => Number(rowScalar(row, 'encounter_creature_deleted') ?? 0) === 0
      && rowScalar(row, 'item_type') === 'player_character'
      && Number(rowScalar(row, 'creature_number') ?? 0) === 0
      && upper(rowScalar(row, 'encounter_id')) !== destinationId
      && (deletedRooms.has(upper(rowScalar(row, 'encounter_id'))) || deletedLocations.has(upper(rowScalar(row, 'encounter_id')))))
    .map(row => upper(rowScalar(row, 'encounter_creature_id'))).filter(Boolean);
  return { destinationId, actorIds: [...new Set(actorIds)], focusCampsite: upper(_ftCamField(campaign, 'encounter_loaded')) !== destinationId };
}

/** All HTML/query callers use the same admission, including tools that load their actors lazily. */
export async function prepareRelocationRequest(url: string, data: Row): Promise<boolean> {
  const route = new URL(url, window.location.href).pathname.split('/').pop() ?? '';
  if (!RELOCATION_ROUTES.has(route) || (route === 'bulk_campaign_join_requests_inc.php' && data.action !== 'accept')) return true;
  if (route === 'set_campaign_campsite_inc.php') {
    try { data.campsite_placement_plan = await campsiteInventoryPlan(data); return true; }
    catch (error) { reportBoundaryError(error, 'campsite-placement'); return false; }
  }
  if (route.startsWith('gm_')) {
    try {
      const saved = await geometryRelocation({ ...data, relocation_route: route });
      const destination = upper(saved.destinationEncounterId);
      // The push saved the campaign pointer. Navigate once from that receipt instead of waiting for a campaign re-read.
      if (route.startsWith('gm_push_') && destination && destination !== upper(window.ftGetActiveEncounterId?.()))
        window.ftSetActiveEncounterId?.(destination, 'party-relocation');
    }
    catch (error) { reportBoundaryError(error, 'gm-relocation'); }
    return false; // The browser commit handled this command; suppress the retired route.
  }

  try {
    const cleanup = route === 'soft_delete_all_locations_except_campaign_campsite_and_campaign_stronghold.php';
    const response = await fetch('/options/tools/encounters/relocation_sources_read_inc.php', { method: 'POST',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...data, relocation_route: route, ...(cleanup ? { source_rows_only: true } : {}) }), signal: AbortSignal.timeout(90000) });
    const facts = record(await response.json());
    if (!response.ok || facts?.ok !== true || !Array.isArray(facts.source_ids)) throw new HandBack('transfer:source-read-unavailable');
    if (cleanup) {
      const { destinationId, actorIds, focusCampsite } = locationCleanupSources(record(facts.cleanup) ?? {});
      if (actorIds.length) {
        // The evacuation's refusal (a member the batch could not prepare, a blocked formation, an unconfirmed save) reaches the GM as a
        // named refusal, worded as the room delete's own toast — never as an unported exception. A Refusal or HandBack keeps its name.
        const refused = (reason: string): Refusal =>
          new Refusal(`Delete refused: the player characters inside could not be moved to the campsite (${reason}).`);
        let saved: Row;
        try {
          saved = await geometryRelocation({ ...data, destination_encounter_id: destinationId, creature_ids: actorIds,
            relocation_route: 'gm_evacuate_encounter_to_campaign_campsite' });
        } catch (error) {
          if (error instanceof Refusal || error instanceof HandBack) throw error;
          throw refused(error instanceof Error ? error.message : String(error));
        }
        if (saved.ok !== true) throw refused(String(saved.error ?? 'location-cleanup:evacuation-refused'));
        // The receipt must cover every selected PC, as the room delete requires: a shortfall would soft-delete rooms with PCs still inside.
        const placed = new Set(normalizePhpListish(saved.placements).map(record).filter((row): row is Row => row !== null).map(row => upper(row.id)));
        const missing = actorIds.filter(id => !placed.has(upper(id)));
        if (missing.length) throw new Refusal(`Delete refused: only ${actorIds.length - missing.length} of ${actorIds.length} player characters inside could be moved to the campsite.`);
      }
      data.location_cleanup_log_transfer = actorIds.length > 0;
      data.location_cleanup_focus_campsite = focusCampsite;
      return true;
    }
    const destinationId = upper(facts.destination_id), sourceIds = facts.source_ids.map(upper);
    if (route === 'link_player_character_inc.php' || route.includes('campaign_join_request')) {
      data.placement_plan = await arrivalPlacementPlans(
        (Array.isArray(facts.arrival_groups) ? facts.arrival_groups : [facts]) as Row[]);
      return true;
    }
    if (!await prepareTransferBoundary(destinationId, sourceIds)) return false;
    if (route.startsWith('mark_player_character_') && destinationId && sourceIds.length) {
      const returning = route.includes('not_') || route === 'mark_player_character_show.php';
      const origins = record(facts.source_encounter_ids) ?? {};
      const destination = record(facts.destination_row);
      const usable = destination && upper(encounterField(destination, 'encounter_id')) === destinationId
        && Number(encounterField(destination, 'encounter_deleted') ?? 0) === 0
        && upper(encounterField(destination, 'encounter_master_parent_id')) === upper(data.campaign_id);
      // Reactivation in the party stays in place; late/no-show retains the campsite arrival behavior.
      // An absent/deleted/foreign campsite still changes attendance, leaving the token where it is.
      if (usable && (!returning || sourceIds.some(id => upper(origins[id]) !== destinationId)))
        await geometryRelocation({ ...data, destination_encounter_id: destinationId, creature_ids: sourceIds });
    }
    // Attendance now saves only scheduling/inactive state and notifications after the browser move.
    return true;
  } catch (error) { reportBoundaryError(error, 'transfer'); return false; }
}

if (typeof window !== 'undefined') Object.assign(window, { ftResolveGmRelocation: resolveGmRelocation,
  ftGeometryStatusExitSkips:(encounterId:string,removals:{status_id:string;before:Row}[])=>{
    const encounter=record(actorEncounterFor(encounterId));if(!encounter)throw new Error('speech:encounter-not-held');
    return previewGmTransferExitEffects([encounter],removals,'speech');
  },
  ftPrepareGmTransfer: prepareGmTransfer, ftPrepareRelocationRequest: prepareRelocationRequest });
